<template>
  <table class="ui two column table">
    <thead>
      <tr>
        <th>Date</th>
        <th>Pickup</th>
        <th>Cancel</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(res, index) in reservations" v-bind:key = "index">
        <td v-for="(address, a_index) in res.addresses" v-if="address.type === 'PICKUP'" v-bind:key = "'thing_' + a_index">{{ address.streetAddress }}, {{ address.city }}, {{ address.state }} {{ address.zip }}</td>
        <td>{{ formatFriendlyDate(res.pickupDateTime) }}</td>
        <td class='right aligned'><i class="close icon"></i></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
  import { twosteau } from './mixins/clients/twosteau.js'
  import { textUtil } from './mixins/textUtil.js'

  export default {
    name: 'Reservations',
    mixins: [twosteau, textUtil],
    data: function () {
      return {
        reservations: {}
      }
    },
    methods: {
      getIdToken: function () {
        return localStorage.id_token
      }
    },
    mounted () {
      this.getReservations(this.getIdToken())
      this.$on('requestReceived', function (data) {
        this.reservations = data
      })
    }
  }
</script>

<style></style>


// WEBPACK FOOTER //
// src/components/Reservations.vue